const md5 = require('md5');

export function isPinCodeWrong(props) {
  return props.infoMessage === 'Wrong PIN.';
}

export function isPasswordWrong(props) {
  return props.infoMessage === 'Wrong password.';
}

export function isPinCodeRequired(props) {
  return (
    props.infoMessage === 'PIN required.' || props.infoMessage === 'Wrong PIN.'
  );
}

export function isRequestReadyToStart(props) {
  return props.requestedDocuments?.length;
}

export function isRequestedDocumentsFirstLoaded(props, prevProps) {
  return (
    props.requestedDocuments?.length &&
    (!prevProps || !prevProps.requestedDocuments?.length)
  );
}

export function isRequestFirstLoaded(props, prevProps) {
  return (
    !props.scanStarted && isRequestedDocumentsFirstLoaded(props, prevProps)
  );
}

export function isCasePasswordRequired(props) {
  return props.casePasswordHint;
}

export function getCasePasswordHint(props) {
  return props.casePasswordHint;
}

export function md5Password(password) {
  return md5(password);
}

export function getDeviceId() {
  if (typeof window === 'undefined') return '';

  const userAgent = navigator.userAgent;
  const fullDomain = window.location.hostname;

  const domainParts = fullDomain.split('.');
  const domainName =
    domainParts.length > 2
      ? domainParts.slice(domainParts.length - 2).join('.')
      : fullDomain;

  console.log(userAgent + domainName);
  return md5(userAgent + domainName);
}

/**
 * Connect iframe credentials from URL / requestStartInfo params.
 * Backend list + listfortemplate require sessionId + deviceId for Connect-gated workflows.
 */
export function getConnectSessionCredentials(params) {
  const sessionId = params?.sessionId || undefined;
  const deviceId = sessionId || params?.embed ? getDeviceId() : undefined;
  return { sessionId, deviceId };
}
